module.exports = __webpack_public_path__ + "img/complaint-vielco.696d15cd.jpg";